export default "skymp5-front/06df934044ee0abe3f64b8add97ba08d.png";